import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

const ColoredDistance = styled.div<{ delta: number }>`
  color: ${props =>
    props.delta > 0 ? 'var(--c-green-400)' : 'var(--c-red-300)'};
`;

type Props = {
  distance: number;
  requiredScore?: number;
  maximumFractionDigits?: number;
  withFromAppendix?: boolean;
};
export const LineupRewardsDistanceLabel = ({
  distance,
  requiredScore,
  withFromAppendix = false,
}: Props) => {
  if (distance === 0 && requiredScore !== 0) {
    return (
      <FormattedMessage
        id="LineupRewardsDistances.zeroScoreDelta"
        defaultMessage="just enough"
      />
    );
  }
  if (distance > 0) {
    return (
      <ColoredDistance delta={distance}>
        <FormattedMessage
          id="LineupRewardsDistances.positiveScoreDelta"
          defaultMessage="{scoreDelta}pts ahead"
          values={{
            scoreDelta: (
              <FormattedNumber
                value={distance}
                maximumFractionDigits={2}
                roundingMode="floor"
              />
            ),
          }}
        />
      </ColoredDistance>
    );
  }
  if (distance < 0) {
    return (
      <ColoredDistance delta={distance}>
        <FormattedMessage
          {...(withFromAppendix
            ? {
                id: 'LineupRewardsDistances.negativeScoreDelta',
                defaultMessage: '{scoreDelta}pts away from',
              }
            : {
                id: 'LineupRewardsDistances.negativeScoreDeltaSimple',
                defaultMessage: '{scoreDelta}pts away',
              })}
          values={{
            scoreDelta: (
              <FormattedNumber
                value={-distance}
                maximumFractionDigits={2}
                roundingMode="floor"
              />
            ),
          }}
        />
      </ColoredDistance>
    );
  }

  return null;
};
